import clsx from 'clsx'
import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'
import { BotIcon } from 'lucide-react'
import { IdEventV4 } from 'models/event'

import { IdentificationUrlKeys } from '../../../types'
import { SmartSignalDefinition } from './SmartSignalRepresentation'

export const botDetectionDefinition: SmartSignalDefinition<Pick<IdEventV4, 'bot' | 'bot_type' | 'bot_info'>> = {
  key: 'bot-detection',
  label: 'Bot',
  extract: (e) => ({
    bot: e.bot,
    bot_type: e.bot_type,
    bot_info: e.bot_info,
  }),
  className(e) {
    const p = this.extract(e)?.bot

    if (p === 'good') {
      return 'text-green-800'
    }

    return 'text-red-800'
  },
  icon(e) {
    const p = this.extract(e)?.bot
    return (
      <BotIcon
        className={clsx('size-4', {
          'text-red-800': p === 'bad',
          'text-green-800': p === 'good',
        })}
      />
    )
  },
  isDetected(e) {
    const p = this.extract(e)?.bot
    return p === 'bad' || p === 'good'
  },
  details(e) {
    return (
      <CodeViewer
        value={formatJSON(this.extract(e))}
        withSearch={false}
        className={this.isDetected(e) ? 'bg-red-100 border-red-300' : 'bg-gray-100'}
      />
    )
  },
  isWeb: () => true,
  isMobile: () => false,
  searchFor: '"bot":',
  documentationHash: '#browser-bot-detection',
  urlParamKey: IdentificationUrlKeys.Bot,
}
